import React, { useEffect, useState } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useSoftUIController, setMiniSidenav, setDrivers, setDeliveries, setPickups, setUser, initWebsocket, closeWebsocket } from "context";
import { getDrivers, getDeliveries, getPickups, getUser } from './actions';

import { Route, Switch, Redirect } from "react-router-dom";

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Sidenav from "components/Sidenav";
import Login from "layouts/login"

import theme from "assets/theme";
import brand from "assets/images/logos/FEI logo-21.png";
import routes from "routes";

const MainContent = () => {    
    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav, sidenavColor, user, websocket, currentDate } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    const isAuthenticated = useIsAuthenticated(); 
    //const isAuthenticated = true;
    const { instance } = useMsal();

    // Open sidenav when mouse enter on mini sidenav
    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
        setMiniSidenav(dispatch, false);
        setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
        setMiniSidenav(dispatch, true);
        setOnMouseEnter(false);
        }
    };

    const getRoutes = (allRoutes) => {
        return allRoutes.map((route) => {
            if (route.collapse) {
                return getRoutes(route.collapse);
            }

            if (route.route) {
                return <Route exact path={route.route} component={route.component} key={route.key} />;
            }

            return null;
        });
    }

    // get the application data
    useEffect(() => {
        Promise.all([getDrivers(), getDeliveries(), getPickups()]).then(res => {
            console.log('tasks', res[1], res[2]);
            setDrivers(dispatch, res[0]);    
            setDeliveries(dispatch, res[1]);
            setPickups(dispatch, res[2]);
            console.log('got pickups', res[2]);        
        }).catch(err => {
            console.error(err.message);        
        });    
    }, []);

    useEffect(() => {

        if(!user) {
            if(isAuthenticated) {
                let accounts = instance.getAllAccounts();
                //let email = 'vciminera@mijara.com'
                if(accounts.length)
                {
                    getUser(accounts[0].username.toLowerCase()).then(u => {
                    //getUser(email).then(u => {
                        console.log('setting user', u);
                        setUser(dispatch, u);
                        if(isAuthenticated && u) {
                            initWebsocket(dispatch, u.email);
                        }
                        else if(websocket) {
                            closeWebsocket(dispatch, websocket);
                        }     
                    });
                }                     
            }            
        }
        else {
            if(isAuthenticated && user) {
                initWebsocket(dispatch, user.email);
            }
            else if(websocket) {
                closeWebsocket(dispatch, websocket);
            }     
        }
        
      }, [isAuthenticated, user])
    
    return (
        <div >           
            <AuthenticatedTemplate>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Sidenav
                        color={sidenavColor}
                        brand={brand}
                        routes={routes}
                        onMouseEnter={handleOnMouseEnter}
                        onMouseLeave={handleOnMouseLeave}
                    />
                    <Switch>
                        {getRoutes(routes)}
                        <Redirect from="*" to="/dashboard" />
                    </Switch>
                </ThemeProvider>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Login />
                </ThemeProvider>     
            </UnauthenticatedTemplate>
        </div>
    );
};

export default MainContent;